export const SET_CURRENT_COMPONENT = 'CADASTRO/SET_CURRENT_STATE';